import GenericColumn from "@isceco/widget-library2/basic-elements/List/column/GenericColumn"
import StringColumn from "@isceco/widget-library2/basic-elements/List/column/StringColumn"
import {html} from '@isceco/widget-library2/external/lit'

export default class AdministrationColumns {

  static getColumns() {
    return [
      AdministrationColumns.KEY_COLUMN(),
      AdministrationColumns.NAME_COLUMN(),
      AdministrationColumns.MONITORING_COLUMN(),
      AdministrationColumns.ACCESS_COLUMN()
    ]
  }

  static KEY_COLUMN() {
    return new StringColumn({
      key: 'formKey',
      text: 'table.header.administration.key',
      sortable: true
    })
  }

  static NAME_COLUMN() {
    return new StringColumn({
      key: 'formName',
      text: 'table.header.administration.name',
      sortable: true
    })
  }

  static MONITORING_COLUMN() {
    return new GenericColumn({
      key: 'monitoringEmails',
      text: 'table.header.administration.monitoring',
      cell: {
        render: (i18n, value, row) => {
          return html`
            <ul>
              ${value.map(email => html`
                <li>${email}</li>`)}
            </ul>
          `
        }
      }
    })
  }

  static ACCESS_COLUMN() {
    return new GenericColumn({
      key: 'accessEmails',
      text: 'table.header.administration.access',
      cell: {
        render: (i18n, value, row) => {
          return html`
            <ul>
              ${value.map(email => html`
                <li>${email}</li>`)}
            </ul>
          `
        }
      }
    })
  }
}
